/**
 * Shared auth / module helpers for Pocket Parliamentarian.
 */

export const MODULE_KEYS = ['meeting', 'committees', 'elections', 'admin'];

/** Canonical org roles. Legacy DB value `Member` is normalized to `Committee`. */
export const ROLES = ['Admin', 'Chair', 'Secretary', 'Committee'];

/** Map legacy / alias role strings to canonical role. */
export function normalizeRole(role) {
  if (role === 'Member') return 'Committee';
  return role;
}

export function defaultModulesForRole(role) {
  const r = normalizeRole(role);
  switch (r) {
    case 'Admin':
      return { meeting: true, committees: true, elections: true, admin: true };
    case 'Chair':
      // President-style: run meetings, committees, elections — not org admin/settings
      return { meeting: true, committees: true, elections: true, admin: false };
    case 'Secretary':
      return { meeting: true, committees: true, elections: false, admin: false };
    case 'Committee':
      return { meeting: false, committees: true, elections: false, admin: false };
    default:
      return { meeting: false, committees: false, elections: false, admin: false };
  }
}

export function normalizeModules(role, modules) {
  const r = normalizeRole(role);
  if (r === 'Admin') {
    return defaultModulesForRole('Admin');
  }
  const base = modules && typeof modules === 'object' ? modules : defaultModulesForRole(r);
  return {
    meeting: Boolean(base.meeting),
    committees: Boolean(base.committees),
    elections: Boolean(base.elections),
    admin: Boolean(base.admin),
  };
}

export function membershipHasModule(membership, moduleName) {
  if (!membership || !membership.is_active) return false;
  const role = normalizeRole(membership.role);
  if (role === 'Admin') return true;
  const modules = membership.modules || {};
  return Boolean(modules[moduleName]);
}

const ACTIVE_ORG_KEY = 'pp_active_organization_id';

export function readActiveOrganizationId() {
  try {
    return localStorage.getItem(ACTIVE_ORG_KEY);
  } catch {
    return null;
  }
}

export function writeActiveOrganizationId(orgId) {
  try {
    if (!orgId) localStorage.removeItem(ACTIVE_ORG_KEY);
    else localStorage.setItem(ACTIVE_ORG_KEY, orgId);
  } catch {
    /* ignore */
  }
}
